exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".photon-label{display:inline-flex;padding:3px 0;color:var(--grey-90)}.photon-label-default{font-size:13px}.photon-label-micro{font-size:11px}", ""]);

